(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;
  document.documentElement.classList.add('mt-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function revelar(el) { el.classList.add('mt-visible'); }

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mt-reveal, .mt-pasos__fila, .mt-tabla-wrap, [data-mt-countup]');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(revelar); els.forEach(function (e) { if (e.dataset.mtCountup) countUp(e, true); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            revelar(en.target);
            if (en.target.dataset.mtCountup) countUp(en.target);
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { if (!el.classList.contains('mt-visible')) io.observe(el); });
  }

  function countUp(el, inst) {
    if (el.dataset.mtCounted) return; el.dataset.mtCounted = '1';
    var fin = parseFloat(el.dataset.mtCountup) || 0, suf = el.dataset.suffix || '', pre = el.dataset.prefix || '';
    if (inst) { el.textContent = pre + fin + suf; return; }
    var t0 = null, dur = 1400;
    function paso(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1); var v = Math.round(fin * (1 - Math.pow(1 - p, 3))); el.textContent = pre + v + suf; if (p < 1) requestAnimationFrame(paso); }
    requestAnimationFrame(paso);
  }

  function formatoEuros(n, moneda) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: moneda || 'USD', maximumFractionDigits: 0 }).format(n); } catch (e) { return '$' + Math.round(n); }
  }

  function initCalculadora() {
    document.querySelectorAll('[data-mt-calc]').forEach(function (c) {
      if (c.dataset.mtInit) return; c.dataset.mtInit = '1';
      var r = c.querySelector('input[type=range]'), out = c.querySelector('[data-mt-calc-valor]'), res = c.querySelector('[data-mt-calc-ahorro]'), pago = c.querySelector('[data-mt-calc-pago]');
      var pct = parseFloat(c.dataset.porcentaje) || 50, precio = parseFloat(c.dataset.precio) || 0, moneda = c.dataset.moneda || 'USD';
      function upd() {
        var v = parseFloat(r.value), min = parseFloat(r.min), max = parseFloat(r.max);
        r.style.setProperty('--mt-p', ((v - min) / (max - min) * 100) + '%');
        out.textContent = formatoEuros(v, moneda);
        var anual = v * 52 * pct / 100;
        res.textContent = formatoEuros(anual, moneda);
        if (pago) {
          var sem = precio > 0 && v > 0 ? Math.ceil(precio / (v * pct / 100)) : 0;
          pago.textContent = sem > 0 ? (c.dataset.textoPago || '').replace('[semanas]', sem) : '';
        }
      }
      r.addEventListener('input', upd); upd();
    });
  }

  function initFaq() {
    document.querySelectorAll('.mt-faq__item').forEach(function (it) {
      if (it.dataset.mtInit) return; it.dataset.mtInit = '1';
      var b = it.querySelector('.mt-faq__q');
      b.addEventListener('click', function () {
        var abierto = it.classList.toggle('mt-abierto');
        b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (g) {
      if (g.dataset.mtInit) return; g.dataset.mtInit = '1';
      var main = g.querySelector('[data-mt-principal]');
      g.querySelectorAll('.mt-pdp__mini').forEach(function (m) {
        m.addEventListener('click', function () {
          g.querySelectorAll('.mt-pdp__mini').forEach(function (x) { x.classList.remove('mt-activa'); });
          m.classList.add('mt-activa');
          main.style.opacity = 0;
          setTimeout(function () { main.src = m.dataset.src; main.srcset = ''; main.alt = m.dataset.alt || ''; main.style.opacity = 1; }, 180);
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (p) {
      if (p.dataset.mtInit) return; p.dataset.mtInit = '1';
      var json = p.querySelector('[data-mt-variantes]');
      if (!json) return;
      var variantes = JSON.parse(json.textContent);
      var input = p.querySelector('input[name=id]'), precio = p.querySelector('[data-mt-precio]'), tachado = p.querySelector('[data-mt-tachado]'), btn = p.querySelector('[data-mt-boton]');
      var txtOk = btn ? btn.dataset.textoOk : '', txtNo = btn ? btn.dataset.textoNo : '';
      var formato = p.dataset.formato || '${{amount}}';
      function dinero(c) {
        var n = (c / 100).toFixed(2);
        var coma = n.replace('.', ',');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma).replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(c / 100));
      }
      function actual() {
        var sel = [];
        p.querySelectorAll('.mt-pdp__opcion').forEach(function (f) { var c = f.querySelector('input:checked'); sel.push(c ? c.value : null); });
        return variantes.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
      }
      p.querySelectorAll('.mt-pdp__opcion input').forEach(function (i) {
        i.addEventListener('change', function () {
          var v = actual();
          if (!v) { if (btn) { btn.disabled = true; btn.querySelector('span').textContent = txtNo; } return; }
          input.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (tachado) { if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; } else { tachado.hidden = true; } }
          if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? txtOk : txtNo; }
          if (v.featured_image) {
            var main = p.querySelector('[data-mt-principal]');
            if (main) { main.src = v.featured_image.src; main.srcset = ''; }
          }
          try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
        });
      });
      var menos = p.querySelector('[data-mt-menos]'), mas = p.querySelector('[data-mt-mas]'), cant = p.querySelector('input[name=quantity]');
      if (menos && mas && cant) {
        menos.addEventListener('click', function () { cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) - 1); });
        mas.addEventListener('click', function () { cant.value = (parseInt(cant.value, 10) || 1) + 1; });
      }
    });
  }

  function initCtaMagnetico() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-mt-magnetico]').forEach(function (b) {
      if (b.dataset.mtInit) return; b.dataset.mtInit = '1';
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width, y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (x * 8) + 'px,' + (y * 6) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  function initTodo() { initReveals(); initCalculadora(); initFaq(); initGaleria(); initVariantes(); initCtaMagnetico(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
